const initialState = {
  checkChromeExtension: false,
};

const chromeExtensionReducer = (state = initialState, action) => {
   switch (action.type) {
    case 'CHROME_EXTENSION':
      state = {
        ...state,
        checkChromeExtension: action.payload,
      };
      break;
    default:
      return state;
  }
  return state;
};

export default chromeExtensionReducer;
